// @flow
// Responsive sizes based off the media queries in variables.css
const baseFontSize = 14;
const tabletFontSize = 16;
const viewMobile = baseFontSize * 40; //560
const viewTablet = tabletFontSize * 40; // 640
const viewDesktop = tabletFontSize * 64; // 1024
const viewLarge = tabletFontSize * 90; // 1440

export const responsiveVars = {
    MIN_TICKS_ON_SCREEN: 4,
    TICKS_PER_DAY: 24,
    MAX_TICKS_MOBILE: 4,
    MAX_TICKS_TABLET: 6,
    MAX_TICKS_DESKTOP: 6,
    MAX_TICKS_LARGE: 8,
    MAX_TICKS_XLARGE: 12,
    VIEW_MOBILE: viewMobile,
    VIEW_TABLET: viewTablet,
    VIEW_DESKTOP: viewDesktop,
    VIEW_LARGE: viewLarge,
    MERGE_THRESHOLD_HOUR: 3,
    MERGE_THRESHOLD_15MINS: 2,
    MERGE_THRESHOLD_10MINS: 5,
    MERGE_THRESHOLD_5MINS: 8,
    MERGE_THRESHOLD_MINS: 0,
    ZOOM_HOUR: 1,
    ZOOM_30MINS: 2,
    ZOOM_15MINS: 4,
    ZOOM_10MINS: 6,
    ZOOM_5MINS: 12,
    ZOOM_2MINS: 30,
    ZOOM_MINS: 60
};

const {
    MERGE_THRESHOLD_HOUR,
    MERGE_THRESHOLD_15MINS,
    MERGE_THRESHOLD_10MINS,
    MERGE_THRESHOLD_5MINS,
    MERGE_THRESHOLD_MINS,
    ZOOM_HOUR,
    ZOOM_30MINS,
    ZOOM_15MINS,
    ZOOM_10MINS,
    ZOOM_5MINS,
    ZOOM_2MINS,
    ZOOM_MINS
} = responsiveVars;

export const increaseZoomMap = {
    [ZOOM_HOUR]: ZOOM_30MINS,
    [ZOOM_30MINS]: ZOOM_15MINS,
    [ZOOM_15MINS]: ZOOM_10MINS,
    [ZOOM_10MINS]: ZOOM_5MINS,
    [ZOOM_5MINS]: ZOOM_2MINS,
    [ZOOM_2MINS]: ZOOM_MINS
};

export const decreaseZoomMap = {
    [ZOOM_MINS]: ZOOM_2MINS,
    [ZOOM_2MINS]: ZOOM_5MINS,
    [ZOOM_5MINS]: ZOOM_10MINS,
    [ZOOM_10MINS]: ZOOM_15MINS,
    [ZOOM_15MINS]: ZOOM_30MINS,
    [ZOOM_30MINS]: ZOOM_HOUR
};

export const mergeThresholdMap = {
    [ZOOM_HOUR]: MERGE_THRESHOLD_HOUR,
    [ZOOM_30MINS]: MERGE_THRESHOLD_HOUR,
    [ZOOM_15MINS]: MERGE_THRESHOLD_15MINS,
    [ZOOM_10MINS]: MERGE_THRESHOLD_10MINS,
    [ZOOM_5MINS]: MERGE_THRESHOLD_5MINS,
    [ZOOM_2MINS]: MERGE_THRESHOLD_MINS,
    [ZOOM_MINS]: MERGE_THRESHOLD_MINS
};



// WEBPACK FOOTER //
// ./src/components/widgets/logs-timeline/constants.js